import { IApplicationState } from '../types/redux';

export const descriptionSelector = (state: IApplicationState) => {
  return state.newbuilding.description;
};
